import { InjectionToken } from "@angular/core";

export const AUTH_SERVER_URL = new InjectionToken<string>('authServerUrl');
export const AUTH_PRODUCT_ID = new InjectionToken<string>('productCode');
export const AUTH_USE_PRODUCT_LOGIN = new InjectionToken<string>('authUseProductLogin');
export const AUTH_MAIN_ACCOUNT_ID = new InjectionToken<string>('authMainAccountId');
export const INVALID_LOGIN_TOKEN_MESSAGE = 'Invalid or expired user login token.';